import { render, staticRenderFns } from "./manual-lti.vue?vue&type=template&id=35e96868&scoped=true&"
import script from "./manual-lti.vue?vue&type=script&lang=js&"
export * from "./manual-lti.vue?vue&type=script&lang=js&"
import style0 from "./manual-lti.vue?vue&type=style&index=0&id=35e96868&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e96868",
  null
  
)

export default component.exports